import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { thunks as ReleaseThunks } from 'reducers/Releases'
import NotificationActions from 'reducers/Notification'
import ReleasesActions from 'reducers/Releases'
import { NotificationType } from 'constants/enums'
import { ReleasesService } from 'services'
import useArchiveToFilter from 'utils/hooks/useArchiveToFilter'

const ArchiveHandlerProvider = ({ release, render, callback }) => {
  const dispatch = useDispatch()
  const { enabled: archiveToFilterEnabled } = useArchiveToFilter()

  const archiveSuccess = () => {
    const currentFlagged = release.flagged
    const currentValue = release.archived

    callback(!currentValue)
    dispatch(
      NotificationActions.broadcastMessage(
        `${release.artist} - ${release.title}`,
        release.archived ? NotificationType.unArchive : NotificationType.archive
      )
    )
    if (currentFlagged && (!archiveToFilterEnabled || !currentValue)) {
      ReleasesService.unFlag(release.releaseid)
      dispatch(
        NotificationActions.broadcastMessage(
          `${release.artist} - ${release.title}`,
          NotificationType.unFlag
        )
      )
    }
  }

  const handleArchive = () => {
    const currentValue = release.archived
    dispatch(
      ReleaseThunks.archive(
        release.releaseid,
        !currentValue,
        archiveSuccess,
        null,
        archiveToFilterEnabled
      )
    )
  }

  const { archived } = release
  return render({ archived, handleArchive })
}

ArchiveHandlerProvider.propTypes = {
  release: PropTypes.object,
  render: PropTypes.func
}

export default ArchiveHandlerProvider
